import React from 'react';
import {Container} from "@material-ui/core";
import {blueGrey} from "@material-ui/core/colors";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: '500',
    },
    semestre: {
        padding: '25px 0'
    },
    titleWithBackgroundImage: {
        background: `url("https://uvt-public-assets.s3-us-west-1.amazonaws.com/privacy.jpeg")`,
        backgroundSize: '100%',
        opacity: '.85',
        backgroundRepeat: 'no-repeat',
        paddingLeft: '70px',
        marginBottom: '25px',
        color: 'white',
        height: '20rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
}));

export default function Privacy() {
    const classes = useStyles();

    return (
        <Container className={classes.root}>
            <div className={classes.titleWithBackgroundImage}>
                <Typography variant="h2" gutterBottom>
                    Privacidad
                </Typography>
                <Typography variant="h3" gutterBottom>
                    Aviso de Privacidad UVT
                </Typography>
            </div>
            <div>
                <Typography variant="body1">
                    Con fundamento en los artículos 15 y 16 de la Ley Federal de Protección de Datos Personales en
                    Posesión de Particulares hacemos de su conocimiento que la Universidad Vasconcelos de Tabasco.,
                    con domicilio en Calle Guayacán Número 202. Col. Quintín Arauz. Paraíso, Tabasco C.P. 86600  México,
                    es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.
                    <br/>
                    Su información personal será utilizada para las siguientes finalidades: proveer el servicio
                    educativo al alumno que ha solicitado informarle de su situación académica, comportamiento, quejas,
                    emisión de documentos y la obtención de su certificado, comunicarle sobre cambios en los mismo,
                    realizar evaluaciones periódicas de nuestros servicios a efecto de mejorar la calidad de los mismos,
                    evaluar la calidad del servicio que brindamos y en general para dar cumplimiento a las obligaciones
                    que hemos contraído con usted. Para las finalidades antes mencionadas, requerimos obtener los siguientes
                    datos personales de usted.
                    <br/>
                    <ul>
                        <li>
                            Nombre completo del estudiante, Edad, Estado civil, fecha y lugar de    nacimiento, sexo,
                            CURP, Acta de nacimiento, certificado de estudios y fotografías.
                        </li>
                        <li>
                            Dirección, teléfono fijo y/o celular, RFC., Correo electrónico, firma autógrafa, Nombre de
                            la Empresa en donde trabaja, domicilio, puesto  y teléfono.
                        </li>
                        <li>
                            Nombre, teléfono y dirección de un familiar autorizado en caso de emergencia.
                        </li>
                    </ul>
                    Es importante informarle que usted tiene derecho al Acceso, Rectificación y Cancelación de sus
                    datos personales.
                    <br/>
                    Así mismo le informamos que sus datos personales serán transferidos a la Secretaría de Educación del
                    Gobierno del Estado de Tabasco, para el registro ante  dichas autoridades, de la historia académica
                    y el otorgamiento del certificado respectivo con reconocimiento de validez oficial, de acuerdo a la
                    Ley General de Educación y el artículo 3° Constitucional.
                </Typography>
            </div>
        </Container>
    );
}

